<template>
  <div>
    <v-btn
      class="Recieve-btn-color"
      style="padding: 15px !important"
      flat
      prepend-icon
      color="white "
      type="button"
      @click="check()"
    >
      Receive/Adjust
    </v-btn>
    <v-dialog
      v-model="dialog"
      max-width="44%"
      persistent
      class="layout__spacing2 accounts-payment-modal"
      content-class="accounts-payment-entry-dialog"
    >
      <v-form
        ref="form"
        v-model="valid"
        :lazy-validation="lazy"
        height="100%"
        onSubmit="return false;"
        class="layout__spacing2"
      >
        <v-card class="accounts-payment-modal-card">
          <v-card-title
            style="
              background-color: #f5f5f5;
              padding-bottom: 5px;
              padding-top: 5px;
            "
          >
            <span class="headline pl-2">Collect Amount From Customer</span>
            <v-spacer></v-spacer>
            <v-btn icon :disabled="processing" @click.prevent="close">
              <v-icon class="heading grey--text text--darken-4">close</v-icon>
            </v-btn>
          </v-card-title>
          <v-progress-linear
            indeterminate
            color="trukkin-theme darken-2"
            v-show="processing"
          ></v-progress-linear>
          <v-spacer class="spacerclassAssign">
            <v-layout class="span__padding" pl-3>
              <v-flex xs8 pl-2>
                <span>How did you receive the amount from the customer?</span>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 pl-4>
                <v-radio-group
                  class="mt-0 pt-0"
                  v-model="modeOfPayment"
                  row
                  :mandatory="true"
                  :rules="[rules.required]"
                >
                  <div>
                    <div class>
                      <v-layout>
                        <v-radio
                          label="Cash"
                          value="Cash"
                          color="black"
                          class="col-md-6"
                        ></v-radio>
                        <v-radio
                          label="Bank Account"
                          value="Bank Account"
                          color="black"
                          class="col-md-6"
                        ></v-radio>
                        <v-radio
                          label="Cheque"
                          value="Cheque"
                          color="black"
                          class="col-md-6"
                        ></v-radio>
                      </v-layout>
                    </div>
                  </div>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout pl-3 style="">
              <v-flex md12 pl-2 class="">
                <v-layout>
                  <v-flex md4 class="custom-label-color">
                    <v-layout>
                      <v-flex md10 class="custom-label-color" pt-20 xs6>
                        <v-text-field
                          v-model="amount"
                          label="Actual Amount Received"
                          placeholder="Enter  Amount"
                          class="pt-0 currencyTitle custom-label-color"
                          maxlength="11"
                          :rules="[rules.noWhiteSpace, rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md8 pr-2>
                    <v-layout>
                      <v-flex xs6 pt-20 pr-1>
                        <v-menu
                          ref="FilterDateBool"
                          lazy
                          v-model="FilterDateBool"
                          class="date__icon"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          full-width
                          :nudge-right="40"
                          :return-value.sync="startDate"
                        >
                          <v-text-field
                            slot="activator"
                            :label="'Select Actual Date '"
                            placeholder="Select Actual Date"
                            v-model="startDate"
                            prepend-icon="event"
                            readonly
                            class="pt-0 currencyTitle custom-label-color"
                            :rules="[rules.noWhiteSpace, rules.required]"
                          ></v-text-field>
                          <v-date-picker
                            v-model="startDate"
                            :max="dateToday"
                            class="minHeight"
                            @change="$refs.FilterDateBool.save(startDate)"
                            no-title
                            scrollable
                          ></v-date-picker>
                        </v-menu>
                      </v-flex>
                      <v-flex
                        xs7
                        md-7
                        pl-5
                        pt-1
                        style="position: relative !important"
                      >
                        <label
                          :class="
                            actualModeError
                              ? 'light_red label__position caption'
                              : 'label__position custom-label-color caption'
                          "
                          >Select Actual Time</label
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          :class="
                            actualModeError
                              ? 'light_red_fill clock_account_pay'
                              : 'clock_account_pay'
                          "
                          height="24"
                          viewBox="0 0 24 24"
                          width="24"
                        >
                          <path
                            d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                          />
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                        </svg>
                        <vue-timepicker
                          class="fonttime4 custom-label-color"
                          :minute-interval="30"
                          v-model="pickupTime"
                          input-width="15em"
                          :label="'Select Actual Time'"
                          placeholder="Select Actual Time"
                          close-on-complete
                          :rules="[rules.noWhiteSpace, rules.required]"
                        ></vue-timepicker>
                        <span
                          v-if="actualModeError"
                          style="
                            color: #ff5252 !important;
                            width: 100%;
                            border: 0px;
                            margin: auto;
                            text-align: left;
                            font-size: 12px;
                            padding-top: 5px;
                            display: block;
                          "
                          >{{ errorMessage }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout pl-4>
              <v-layout
                v-if="
                  modeOfPayment === 'Bank Account' || modeOfPayment === 'Cheque'
                "
              >
                <v-flex md4 class="">
                  <v-layout>
                    <v-flex md10 class="" pt-20>
                      <v-text-field
                        v-model="remitterBankInstrumentNo"
                        label="Instrument Number"
                        placeholder="Instrument Number"
                        class="pt-0 currencyTitle custom-label-color"
                        :rules="[rules.noWhiteSpace, rules.required]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex>
                  <v-layout>
                    <v-flex xs11 pt-20 pr-1>
                      <v-menu
                        ref="FilterDateBool2"
                        lazy
                        v-model="FilterDateBool2"
                        class="date__icon"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        full-width
                        :nudge-right="40"
                        :return-value.sync="InstrumentDate"
                      >
                        <v-text-field
                          slot="activator"
                          :label="'Select Insturment Date'"
                          placeholder="Select Insturment Date"
                          v-model="InstrumentDate"
                          prepend-icon="event"
                          readonly
                          class="pt-0 currencyTitle custom-label-color"
                          :rules="[rules.noWhiteSpace, rules.required]"
                        ></v-text-field>
                        <v-date-picker
                          v-model="InstrumentDate"
                          :max="dateToday"
                          class="minHeight"
                          @change="$refs.FilterDateBool2.save(InstrumentDate)"
                          no-title
                          scrollable
                        ></v-date-picker>
                      </v-menu>
                    </v-flex>
                    <!-- <v-text-field
                        v-model="ibanNumber"
                        label="IBAN Number "
                        placeholder="Enter IBAN Number "
                        class="pt-0 currencyTitle custom-label-color"
                        :rules="[rules.noWhiteSpace, rules.required]"
                      ></v-text-field> -->
                  </v-layout></v-flex
                >
                <v-flex>
                  <v-layout>
                    <v-flex md10 class="" pt-20 pl-2>
                      <v-autocomplete
                        label="Select Instrument Type"
                        placeholder="Select Instrument Type"
                        :items="instrumentTypes"
                        class="pt-0 currencyTitle custom-label-color"
                        v-model="remitterBankInstrumentType"
                        item-text="text"
                        item-value="value"
                        :rules="[rules.noWhiteSpace, rules.required]"
                      />
                      <!-- <v-text-field
                      v-model="accountNumber"
                      label="Account Number"
                      placeholder="Enter Account Number"
                      class="pt-0 currencyTitle custom-label-color"
                      :rules="[rules.noWhiteSpace, rules.required]"
                    ></v-text-field> -->
                    </v-flex>
                  </v-layout></v-flex
                >
              </v-layout>
            </v-layout>
            <v-layout pl-4>
              <v-layout
                v-if="
                  modeOfPayment === 'Bank Account' || modeOfPayment === 'Cheque'
                "
              >
                <v-flex md4 class="">
                  <v-layout>
                    <v-flex md10 class="" pt-20>
                      <v-autocomplete
                        label="Select Bank Name"
                        placeholder="Select Bank Name"
                        :items="bankLegerCollection"
                        class="pt-0 currencyTitle custom-label-color"
                        v-model="bankName"
                        item-text="text"
                        item-value="value"
                        :rules="[rules.noWhiteSpace, rules.required]"
                      />

                      <!-- <v-text-field
                        v-model="bankName"
                        label="Bank Name"
                        placeholder="Enter Bank Name"
                        class="pt-0 currencyTitle custom-label-color"
                        :rules="[rules.noWhiteSpace, rules.required]"
                      ></v-text-field> -->
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md4 pr-2 v-if="modeOfPayment === 'Cheque'">
                  <v-layout>
                    <v-flex class="maxw214" pt-20>
                      <v-text-field
                        label="Cheque No."
                        v-model="checkNumber"
                        class="pt-0 currencyTitle custom-label-color"
                        placeholder="Enter Cheque No."
                        :rules="[rules.noWhiteSpace, rules.required]"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex md4 pr-2 v-if="modeOfPayment === 'Bank Account'">
                  <v-layout>
                    <v-flex class="maxw214" pt-20>
                      <v-text-field
                        v-model="remitterBankName"
                        label="Remitter Bank Name "
                        placeholder="Enter Remitter Bank Name "
                        class="pt-0 currencyTitle custom-label-color"
                        :rules="[rules.noWhiteSpace, rules.required]"
                        maxlength="80"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-layout>

            <v-layout>
              <v-flex xs12>
                <v-layout> </v-layout>
                <v-layout pt-20 pl-2>
                  <v-flex md12>
                    <v-card-title class="title-layout-size"> </v-card-title>
                    <v-card-text class="title-layout-size">
                      <v-text-field
                        label="Comment"
                        v-model="comment"
                        class="pt-0 currencyTitle custom-label-color"
                        placeholder="Enter Comment"
                        :rules="[rules.noWhiteSpace, rules.required]"
                        maxlength="150"
                      ></v-text-field>
                    </v-card-text>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex md12 class="payadvance">
                    <v-flex
                      xs7
                      class="pt-3 pt-100 pl-4"
                      v-if="document.length < 5"
                    >
                      <div class="upload-btn-wrapper pl-1">
                        <button v-if="document.length < 5" class="btn">
                          <v-icon small color="orange">upload</v-icon> Upload
                          Proofs
                        </button>
                        <input
                          ref="fileUpload"
                          id="fileUpload"
                          type="file"
                          multiple
                          accept=".pdf, .jpeg, .jpg, .png"
                          @change="uploadDocument"
                        />
                      </div> </v-flex
                  ></v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs6>
                <v-layout v-if="modeOfPayment === 'Cash'">
                  <v-flex md11 pt-20 pl-3 class="payadvance">
                    <v-text-field
                      label="Collected By"
                      v-model="cashHandover"
                      class="pt-0 currencyTitle custom-label-color"
                      placeholder="Enter Collected By"
                      :rules="[rules.noWhiteSpace, rules.required]"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex md12 class="payadvance">
                    <ul style="padding-top: 10px !important">
                      <li
                        style="position: relative"
                        :key="i"
                        v-for="(doc, i) in document"
                        class="list"
                        ref="documentList"
                      >
                        <button
                          type="button"
                          v-show="document"
                          @click="removeImage(i)"
                        >
                          <span class="close imageClose">&times;</span>
                        </button>
                        <a
                          :href="doc"
                          class="document-link"
                          v-if="doc.substr(doc.lastIndexOf('.') + 1) === 'pdf'"
                          target="_blank"
                        >
                          <img src="../../../../assets/pfd.png" />
                        </a>
                        <a
                          :href="doc"
                          class="document-link"
                          target="_blank"
                          v-else
                        >
                          <img
                            src="../../../../assets/docimg.webp"
                            height="72"
                            width="75"
                          />
                        </a>
                      </li>
                    </ul>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout pt-2>
              <span class="headline pl-4 mt-4"
                >Adjust Amount Against Sales Invoices</span
              >
            </v-layout>
            <v-layout pt-1>
              <span class="pl-4 mt-1">Sales Invoice Types</span>
            </v-layout>

            <v-layout>
              <v-flex xs12 pl-4>
                <v-radio-group
                  class="mt-0 pt-0"
                  v-model="modeOfAdjust"
                  row
                  :mandatory="true"
                  :disable="adjustedInvoice.length"
                  @change="
                    fetchInvoice();
                    clearData();
                  "
                  :rules="[rules.required]"
                >
                  <div>
                    <div class>
                      <v-layout>
                        <v-radio
                          label="Job Level"
                          value="JOB"
                          color="black"
                          class="col-md-6"
                        ></v-radio>
                        <v-radio
                          label="Assignment Level"
                          value="ASSIGNMENT"
                          color="black"
                          class="col-md-6"
                        ></v-radio>
                      </v-layout>
                    </div>
                  </div>
                </v-radio-group>
              </v-flex>
            </v-layout>

            <v-layout :key="i" v-for="(checklist, i) in adjustedInvoice">
              <v-flex xs4 class="" pl-4 style="word-break: break-all">
                <v-autocomplete
                  label="Choose Invoice Number"
                  placeholder="Choose Invoice Number"
                  :items="checklist.search ? searchcustomers : customers"
                  item-text="text"
                  item-value="text"
                  class="custom-label-color"
                  v-model="checklist.invoiceNumber"
                  :search-input.sync="checklist.search"
                  @change="
                    setCustomerValues($event, i, checklist.invoiceNumber)
                  "
                  @keyup.enter="searchAnything($event, i, checklist.search)"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs4 pl-4 style="word-break: break-all">
                <v-text-field
                  v-model="checklist.adjustedAmount"
                  :value="checklist.adjustedAmount"
                  label=" Enter Amount To Be Adjusted"
                  class="custom-label-color"
                  type="number"
                >
                </v-text-field>
              </v-flex>

              <v-flex v-if="adjustedInvoice.length != 1" xs2 class="pt-3 pl-4">
                <div class="upload-btn-wrapper">
                  <button
                    style="border: 2px solid red; color: red"
                    @click="removeRow(i)"
                    type="button"
                    class="btn"
                  >
                    Remove
                  </button>
                </div>
              </v-flex>

              <v-flex v-if="adjustedInvoice.length == 1" xs2 class="pt-3 pl-4">
                <div class="upload-btn-wrapper">
                  <button
                    style="border: 2px solid red !important; color: red"
                    @click="clearData()"
                    type="button"
                    class="btn"
                  >
                    Remove
                  </button>
                </div>
              </v-flex>
            </v-layout>

            <v-layout pl-4>
              <div
                v-if="this.adjustedInvoice.length <= 10"
                class="upload-btn-wrapper"
              >
                <button
                  style="border: 2px solid green !important; color: green"
                  @click="addMore"
                  class="btn"
                  type="button"
                >
                  + Add More
                </button>
              </div>
            </v-layout>

            <v-spacer></v-spacer>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red darken-1"
                :disabled="processing"
                flat
                @click="close()"
                >Cancel</v-btn
              >
              <v-btn
                color="white darken-1"
                style="background: #ea7a1c !important"
                :disabled="processing"
                flat
                @click="receieveAmount()"
                >Submit</v-btn
              >
            </v-card-actions>
          </v-spacer>
        </v-card>
      </v-form>
      <v-dialog
        v-model="confirmationDialog"
        max-width="23%"
        persistent
        content-class="accounts-payment-confirm-dialog"
      >
        <v-card class="accounts-payment-confirm-card">
          <v-spacer class="spacerclass">
            <v-card-text style="padding-top: 0px !important">
              <v-layout class="pt-4" style="text-align: center">
                <v-flex pr-2 pb-3>
                  <v-icon x-large color="orange">info</v-icon></v-flex
                >
              </v-layout>
              <v-layout>
                <v-flex pb-3 style="text-align: center">
                  {{ confirmationData }}
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex style="text-align: center">
                  <v-btn
                    color="white darken-1"
                    style="
                      background: #ea7a1c !important;
                      min-width: 66px !important;
                    "
                    flat
                    @click.prevent="confirm()"
                    >OK</v-btn
                  ></v-flex
                >
              </v-layout>
            </v-card-text>
          </v-spacer>
        </v-card>

        <v-snackbar
          :timeout="3000"
          bottom
          color="red darken-2"
          v-model="x.error"
          class="white--text"
          v-if="error"
          >{{ error }}</v-snackbar
        >
      </v-dialog>
      <v-snackbar
        :timeout="3000"
        bottom
        color="red darken-2"
        v-model="x.error"
        class="white--text"
        v-if="x.error"
        >{{ x.error }}</v-snackbar
      >
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import { StorageKeys, Banks } from "../../../../constants/constants";
import { uploadImage } from "../../../../constants/api-urls";
import { recieveAdjust, recieveBankLedger } from "@/constants/api-urls.js";

import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
export default {
  created() {
    this.customerStatus = localStorage.getItem("cust-status");

    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = workingCountry;

      this.payload = {
        workingCountry: this.workingCountry,
      };
    }
  },

  data() {
    return {
      dateToday: moment(new Date()).format("YYYY-MM-DD"),
      errorMessage: "This field is required.",
      error: "",
      operationName: "",
      actualModeError: false,
      error: null,
      search: null,
      confirmationData: "",
      customers: [],
      searchcustomers: [],
      banks: [],
      confirmationDialog: false,
      options: {
        color: "#ffc04c",
        width: 500,
        zIndex: 200,
      },
      bankName: "",
      activity: [],
      pickupTime: {
        HH: "",
        mm: "",
      },
      checkNumber: "",
      startDate: "",
      InstrumentDate: "",
      cashHandover: "",
      FilterDateBool: false,
      FilterDateBool2: false,

      modeOfPayment: "Cash",
      modeOfAdjust: "JOB",
      customerStatus: "",
      remitterBankName: "",
      comment: "",
      remitterBankInstrumentType: "",
      remitterBankInstrumentNo: "",
      ibanNumber: "",
      ifscCode: "",
      amount: "",
      valid: true,
      lazy: false,
      index: 0,
      invoiceNumber: "",
      invoiceValue: "",
      document: [],
      adjustedInvoice: [
        {
          i: 0,
          invoiceNumber: null,
          adjustedAmount: 0,
          search: null,
        },
      ],
      receiveData: [
        {
          i: 0,
          invoiceNumber: null,
          adjustedAmount: 0,
        },
      ],

      document: [],
      documentType: [],
      bankLegerCollection: [],
      instrumentTypes: [],
      reason: "",
      processing: false,
      sumAdjust: 0,
      dialog: false,
      disStatus: false,
      loading: false,
      advancePayment: null,
      rules: {
        required: (value) => !!value || "This field is required.",
        noWhiteSpace: (v) =>
          (v != null && v.trim().length > 0) || "Enter valid value.",
        amount: (v) =>
          /^\d*(\.\d+)?$/.test(v) || "Enter a valid amount. E.g 10 or 10.20",
        number: (v) => /^[0-9]*$/.test(v) || "Please enter valid amount",
      },
      x: {
        error: null,
      },
    };
  },
  components: {
    VueTimepicker,
  },
  watch: {
    pickupTime(val) {
      //  this.actualModeError = false;

      if (val.HH || val.mm) {
        this.actualModeError = false;
      }
    },
  },
  props: {
    advance: Number,
    currency: String,
    selectedCustomerWorkingCoun: String,
    customerId: String,
    status: Number,
    advancedialog: Boolean,
    type: String,
  },

  methods: {
    //remove Image via close icon

    removeImage(key) {
      this.document.splice(key, 1);
    },
    getBankNdInstrument() {
      this.loading = true;
      let url = recieveBankLedger;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      console.log(this.$props.selectedCustomerWorkingCoun);
      let country = this.$props.selectedCustomerWorkingCoun;
      this.axios
        .get(this.constants.apiUrl + url + "?country=" + country, config)
        .then(
          (res) => {
            this.bankLegerCollection = res.data.data.bankLegerCollection;
            this.instrumentTypes = res.data.data.instrumentTypes;
            console.log(res.data.data.bankLegerCollection);
          },
          (error) => {
            this.x.error = "Failed to Fetch Admin";
            this.loading = false;
          }
        );
    },
    searchAnything(val, index, s) {
      this.searchcustomers = [];
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.t = config.headers.authorization;
      let body = {
        workingCountry: this.workingCountry,
        invoiceNumber: s,
        invoiceLevel: this.modeOfAdjust,
        customerId: this.$props.customerId,
      };
      this.axios
        .post(
          `${this.constants.apiUrl}/customerPayment/listInvoice`,
          body,
          config
        )
        .then((response) => {
          const { data = null } = response.data;

          data.forEach((element) => {
            this.searchcustomers.push({
              text: element.invoiceNumber,
              value: element.outStandingAmount,
            });
          });
        });
    },
    setCustomerValues(val, index, p) {
      this.adjustedInvoice.filter((a) => {
        if (a.invoiceNumber == val) {
          if (a.i !== index) {
            this.x.error = `Please remove  duplicate invoice Number ${a.invoiceNumber}`;
            return false;
          }
        }
      });

      var data = this.customers.filter((v) => {
        if (v.text === val) return v;
      });

      this.adjustedInvoice.forEach((a) => {
        if (a.i == index) {
          a.adjustedAmount = data[0].value;
        }
      });

      this.adjustedInvoice.forEach((a) => {
        this.adjustedInvoice.filter((p) => {
          if (p.invoiceNumber == a.invoiceNumber) {
          }
        });
      });
    },

    fetchInvoice() {
      this.customers = [];
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.t = config.headers.authorization;
      let body = {
        workingCountry: this.workingCountry,

        invoiceLevel: this.modeOfAdjust,
        customerId: this.$props.customerId,
      };
      this.axios
        .post(
          `${this.constants.apiUrl}/customerPayment/listInvoice`,
          body,
          config
        )
        .then((response) => {
          const { data = null } = response.data;

          data.forEach((element) => {
            this.customers.push({
              text: element.invoiceNumber,
              value: element.outStandingAmount,
              losttAmount: element.lossToTrukkin,
            });
          });
        });
    },

    addMore() {
      let el = this.adjustedInvoice.length;

      let checklist = {
        i: el - 1 + 1,
        adjustedAmount: 0,
        invoiceNumber: null,
        search: null,
      };
      this.adjustedInvoice.push(checklist);
    },

    uploadDocument(e) {
      this.x.error = null;
      var files = e.target.files || e.dataTransfer.files;
      let x = [...files];
      setTimeout(() => {
        this.$refs.fileUpload.value = "";
      }, 6000);
      if (!files.length) return;

      Array.from(x).forEach((y, i) => {
        this.createImage(files[i]);
      });
    },
    //createImage file check size of image/Document
    createImage(file) {
      let size = file.size / 1024 / 1024;
      // -------- FILE SIZE CHECK
      if (size > 5) {
        this.x.error = "Please upload proof with size less than 5MB!";

        return false;
      }
      if (
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/png" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !== "image/jpeg" &&
        file.type
          .toString()
          .substr(file.type.toString().lastIndexOf(".") + 1) !==
          "application/pdf"
      ) {
        this.x.error =
          "Please upload proof of file type png , jpg ,jpeg or pdf!";
        return false;
      } else {
        var image = new Image();
        var reader = new FileReader();
        var vm = this;

        reader.onload = (e) => {
          vm.image = e.target.result;
        };
        reader.readAsDataURL(file);
        this.upload(file);
      }
    },

    //upload function for upload document
    upload(file) {
      this.processing = true;
      const formData = new FormData();
      formData.append("image", file);
      this.axios({
        url: `${this.constants.apiUrl}${uploadImage}`,
        method: "POST",
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then(
        (response) => {
          this.processing = false;
          const { statusCode } = response.data;
          if (statusCode === 200) {
            if (this.document.length < 5) {
              this.document.push(response.data.data.original);
            } else {
              this.x.error = "Maximum 5 proofs can be uploaded!";
              return false;
            }
          } else {
            this.x.error = "Failed to upload image";
          }
          this.loading = false;
        },
        (error) => {
          this.x.error = "Failed to upload image";
          this.processing = false;
        }
      );
    },

    //check permission of user have access
    async check() {
      this.dialog = true;
      this.modeOfPayment = "Cash";
      this.modeOfAdjust = "JOB";
      this.fetchInvoice();
      this.getBankNdInstrument();
    },

    //close popup
    close() {
      this.actualModeError = false;
      this.dialog = false;
      this.processing = false;
      this.$refs.form.resetValidation();
      this.cashHandover = "";
      this.startDate = null;
      this.InstrumentDate = null;
      this.amount = "";
      this.customers = [];
      (this.adjustedInvoice = [
        {
          i: 0,
          invoiceNumber: null,
          adjustedAmount: 0,
          search: null,
        },
      ]),
        (this.pickupTime = {
          HH: "",
          mm: "",
        }),
        (this.modeOfPayment = "");
      this.modeOfAdjust = "";
      this.remitterBankName = "";
      this.remitterBankInstrumentType = "";
      this.remitterBankInstrumentNo = "";
      this.comment = "";
      this.ifscCode = "";
      this.bankName = "";
      this.document = [];
      this.checkNumber = "";
      this.adjustedInvoice;
      this.FilterDateBool = false;
      this.FilterDateBool2 = false;

      this.ibanNumber = "";
      this.advancePayment = null;
    },

    //TIME CONVERTER
    getTime(date) {
      return moment(date).format("YYYY-MM-DD hh:mm A");
    },

    checkTime() {
      let re = /^\d{1,2}:\d{2}([ap]m)?$/;
      var time = this.pickupTime.HH + ":" + this.pickupTime.mm;

      if (time != "" && !time.match(re)) {
        this.actualModeError = true;
        this.x.error = "Please select the valid time before moving ahead!";

        return false;
      }
    },

    removeRow(i) {
      if (this.adjustedInvoice.length == 1) {
        return;
      } else {
        let el = this.adjustedInvoice;
        el.splice(i, 1);
        this.adjustedInvoice = el;
      }
    },
    clearData() {
      this.adjustedInvoice = [
        {
          i: 0,
          invoiceNumber: null,
          adjustedAmount: 0,
          search: null,
        },
      ];
    },

    confirm() {
      this.confirmationDialog = false;
    },

    //SUBMIT AFTER FILL ALL FORM

    receieveAmount() {
      this.processing = true;
      console.log(this.adjustedInvoice);
      console.log(this.adjustedInvoice.every((e) => e.invoiceNumber));

      this.sumAdjust = this.adjustedInvoice.reduce(function (acc, obj) {
        return Number(acc) + Number(obj.adjustedAmount);
      }, 0);
      if (this.sumAdjust) {
        if (!this.adjustedInvoice.every((e) => e.invoiceNumber)) {
          this.processing = false;
          this.x.error =
            "Please  fill field of adjusted outstanding amount otherwise remove from listing";
          return;
        }
      }

      if (this.$refs.form.validate()) {
        if (this.sumAdjust > this.amount) {
          this.processing = false;
          this.x.error =
            "Adjusted amount is greater than the received amount for this entry";
          return;
        }

        if (this.pickupTime) {
          this.checkTime();

          let currentDate = moment(new Date()).format("YYYY-MM-DD, HH:mm");
          let selectedDateTime =
            this.startDate +
            "," +
            this.pickupTime.HH +
            ":" +
            this.pickupTime.mm;

          if (
            new Date(currentDate).getTime() <
            new Date(selectedDateTime).getTime()
          ) {
            this.loading = false;
            this.processing = false;
            this.x.error =
              "Please select the past time and date before moving ahead!";
            return false;
          }
        }
        if (!this.document.length) {
          this.x.error = "Please upload proof of physical document";
          this.processing = false;

          return false;
        }
        this.adjustedInvoice.forEach((e) => {
          this.customers.filter((p) => {
            if (e.invoiceNumber === p.text) {
              if (
                p.value - e.adjustedAmount + p.losttAmount < 1 &&
                p.value - e.adjustedAmount + p.losttAmount > 0 &&
                p.value - e.adjustedAmount > 0 &&
                p.value - e.adjustedAmount < 1
              ) {
                this.loading = false;

                this.confirmationData = ` Remaining amount of ${(
                  p.value -
                  e.adjustedAmount +
                  p.losttAmount
                ).toFixed(2)} for  ${
                  e.invoiceNumber
                } will be marked automatically as Loss To Trukkin.`;
                this.confirmationDialog = true;
              }
            }
          });
        });

        let url = recieveAdjust;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };

        let body = {
          customer_id: this.$props.customerId,
          amount: parseFloat(this.amount),
          actualReceivedDate: this.startDate,
          actualReceivedTime: this.pickupTime.HH + ":" + this.pickupTime.mm,
          paymentMode: this.modeOfPayment,
          paymentProof: this.document,
          depositComments: this.comment,
          invoiceLevel: this.modeOfAdjust,
        };
        if (this.adjustedInvoice[0].invoiceNumber) {
          let adjust = [];

          adjust = this.adjustedInvoice.map(
            ({ invoiceNumber, adjustedAmount }) => {
              return { invoiceNumber, adjustedAmount };
            }
          );
          body.adjustData = adjust;
        }
        if (this.cashHandover) {
          body.cashReceivedBy = this.cashHandover;
        }
        console.log(this.bankName);
        if (this.bankName) {
          body.bankName = this.bankName;
        }
        if (this.InstrumentDate) {
          body.remitterBankInstrumentDate = this.InstrumentDate;
        }
        if (this.checkNumber) {
          body.chequeNumber = this.checkNumber;
        }
        if (this.remitterBankInstrumentNo) {
          body.remitterBankInstrumentNo = this.remitterBankInstrumentNo;
        }
        if (this.remitterBankName) {
          body.remitterBankName = this.remitterBankName;
        }
        if (this.remitterBankInstrumentType) {
          body.remitterBankInstrumentType = this.remitterBankInstrumentType;
        }
        if (this.ibanNumber) {
          body.ibanNumber = this.ibanNumber;
        }

        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.x.success = true;
            this.dialog = false;
            this.processing = false;
            this.$refs.form.resetValidation();
            this.cashHandover = "";
            this.startDate = null;
            this.InstrumentDate = null;
            this.amount = "";
            this.pickupTime = {
              HH: "",
              mm: "",
            };
            this.modeOfPayment = "";
            this.modeOfAdjust = "";
            this.remitterBankName = "";
            this.checkNumber = "";
            this.remitterBankInstrumentType = "";
            this.remitterBankInstrumentNo = "";
            this.ibanNumber = "";
            this.comment = "";
            this.ifscCode = "";
            this.bankName = "";
            this.document = [];
            (this.adjustedInvoice = [
              {
                i: 0,
                invoiceNumber: null,
                adjustedAmount: 0,
                search: null,
              },
            ]),
              (this.advancePayment = null);

            // this.$emit("generater-Receieve-Pay");
          },
          (error) => {
            this.processing = false;
            this.x.error = error.response.data.message;
          }
        );
      } else {
        this.processing = false;
        if (this.pickupTime.HH == "" && this.pickupTime.mm == "") {
          this.actualModeError = true;
          this.errorMessage = "This field is required.";

          return false;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.layout__spacing2 .v-input__slot {
  min-height: auto !important;
}
.layout__spacing2 .v-text-field__slot input {
  margin-top: 0px !important;
}
.custom-label-color label.v-label.v-label--active.theme--light {
  top: 8px !important;
  color: #000000;
}
</style>
<style scoped>
.spacerclassAssign {
  overflow-y: scroll !important;
  max-height: calc(104vh - 176px) !important;
}
.tra-ass-btn {
  text-decoration: none;
  margin: 7px !important;
  color: white;
  background-color: #539b56;
  border-radius: 5px;
  border: 2px solid #539b56;
  padding: 6px 6px;
}
.heading__span {
  font-size: 20px !important;
  line-height: 32px !important;
  font-weight: bold;
}
.span__padding {
  padding: 10px 10px 10px 16px;
}
.dashboard-style {
  color: grey;
  font-size: 16px;
  font-weight: 700;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}
.upload-btn-wrapper a {
  margin-left: 10px;
}

.upload-btn-wrapper .btn,
.upload-btn-wrapper .view-btn {
  border: 2px solid #ea7a1c;
  color: #ea7a1c;
  background-color: white;
  padding: 8px 8px;
  cursor: pointer !important;
  border-radius: 8px;
  font-size: 14px;
  font-weight: bold;
}
.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.vue__time-picker input.display-time {
  border-radius: 0px !important;
  border-bottom: 1px solid #d2d2d2 !important;
  border: none;
  padding: 0px !important;
}
.messagebtn {
  margin: 0 auto;
}
.label__position {
  position: relative;
  top: 2px;
}
.title-layout-size {
  padding: 0px 16px !important;
}
.title {
  font-size: 18px;
  font-weight: 500;
}
.list {
  display: inline-block;
  position: relative;
}
.Recieve-btn-color {
  background-color: #539b56 !important;
  text-transform: capitalize;
}
.fonttime4 {
  font-size: 11px !important;
}

::v-deep .fonttime4 input::placeholder {
  font-size: 12px !important;
  color: #b5b5b5;
  font-family: "Roboto", sans-serif;
  font-weight: 200;
}

.fonttime4 .dropdown.drop-down {
  top: -14%;
}
.currencyTitle {
  margin-top: -2px !important;
}
label.v-label.v-label--active.theme--light {
  color: red !important;
  opacity: 1;
}
label.v-label.v-label--active.theme--light {
  top: 8px !important;
  color: #000000;
}
.maxw214 {
  max-width: 214px;
}

::v-deep .fonttime4 .controls .clear-btn {
  display: none !important;
  opacity: 0;
}
</style>
